"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var TriggerContext = /*#__PURE__*/React.createContext(null);
var _default = TriggerContext;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-trigger/lib/context.js
// module id = 1124
// module chunks = 0